var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.6 10.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6,2.1c0.6,0,1.1-0.5,1.1-1.1S10.1,0,9.6,0H1v0C0.5,0,0,0.5,0,1.1s0.5,1,1,1.1v0H9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,10.6c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1H1v0C0.5,8.5,0,9,0,9.6s0.5,1,1,1.1v0H9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,6.4c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1H1v0c-0.6,0-1,0.5-1,1.1s0.5,1,1,1.1v0H9.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.79c52719124d6feb09b9db873b0788dc.svg";
export { ForwardRef as ReactComponent };